// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__27Q7t","log":"ModalInventoryLogs_log__3959b","date":"ModalInventoryLogs_date__2lyV4","userName":"ModalInventoryLogs_userName__1EfYS"};